<div mat-dialog-title>
  <h2>Atenção</h2>
</div>
<div mat-dialog-content>
  <p class="nota">
    Estão selecionados os itens que compõe os  dois Itinerários, volte na tela  anterior e opte somente por uma das opções  abaixo, Ciências Humanas ou Ciências da Natureza.
  </p>

  <p class="titulo"><strong>Opção 1 - Ciências Humanas</strong></p>
  <ul>
    <li class="item" *ngFor="let item of itens_humanas">{{item}}</li>
  </ul>

  <p class="titulo"><strong>Opção 2 - Ciências da Natureza</strong></p>
  <ul>
    <li class="item" *ngFor="let item of itens_natureza">{{item}}</li>
  </ul>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button cdkFocusInitial color="primary" [mat-dialog-close]="true">
      Ok
    </button>
</div>